// extracted by mini-css-extract-plugin
export default {"contentContainer":"RefundTransactionContent_contentContainer__Q+7we","spinContainer":"RefundTransactionContent_spinContainer__kk6Ix"};